"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Selector = void 0;
var React = require("react");
var classnames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var getCategory_1 = require("utils/helpers/getCategory");
var Selector = function (props) {
    var _a;
    var group = props.items.find(function (_a) {
        var id = _a.id;
        return id === props.groupId;
    });
    return (React.createElement(sok_ui_1.Dropdown2, { className: 'selector', alignment: 'left' },
        React.createElement(sok_ui_1.TextInput, { editable: false, value: (_a = group === null || group === void 0 ? void 0 : group.name) !== null && _a !== void 0 ? _a : (0, translation_1.getLocalization)('components/modals/genericInvitationModal/pleaseSelectUserGroup'), iconRight: React.createElement("span", { className: 'icon-container' },
                React.createElement(Icon_1.Icon, { className: 'fa-chevron-down' })) }),
        React.createElement(sok_ui_1.Dropdown2Menu, { className: 'generic-invite-modal-dropdown' }, props.items.map(function (item, index) {
            var selected = group && group.id === item.id;
            if (item.id !== -2) {
                return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: "".concat(index, "_").concat(item.id), selected: selected, className: classnames('invitation-row', item.disabled && 'disabled'), onClick: function () {
                        return !item.disabled && props.selectItem(props.uuid, item.id);
                    } }, item.disabled ? (React.createElement("strong", null, (0, getCategory_1.getCategoryName)(item))) : (React.createElement("span", null, item.name))));
            }
        }))));
};
exports.Selector = Selector;
